const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  multiTab: state => state.app.multiTab,
  token: state => state.user.token,
  headPic: state => state.user.headPic,
  nickName: state => state.user.nickName,
  account: state => state.user.account,
  accountId: state => state.user.accountId,
  tenantName: state => state.user.tenantName,
  tenantSystemName: state => state.user.tenantSystemName,
  tenantSystemLogo: state => state.user.tenantSystemLogo,
  notice: state => state.user.notice
}

export default getters
